import { render, staticRenderFns } from "./RbHomeView.vue?vue&type=template&id=6240ef76&"
import script from "./RbHomeView.vue?vue&type=script&lang=js&"
export * from "./RbHomeView.vue?vue&type=script&lang=js&"
import style0 from "./RbHomeView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports